import { makeAutoObservable } from 'mobx'
import { checkSingleUrl, EnumCheckUrlStatus } from 'entities/Compliance'

type IReachableUrlStoreConfig = {
  errorText: string
  warningText: string
}

export class ReachableUrlStore {
  private _errorText = ''
  private _warningText = ''
  private _status: EnumCheckUrlStatus | null = null
  private _domainCheck = false

  constructor(private _config: IReachableUrlStoreConfig) {
    makeAutoObservable(this)
  }

  setError = (value: string) => {
    this._errorText = value
  }

  setWarning = (value: string) => {
    this._warningText = value
  }

  setStatus = (value: EnumCheckUrlStatus | null) => {
    this._status = value
  }

  setDomainCheck = (value: boolean) => {
    this._domainCheck = value
  }

  checkSingleUrl = async (url: string) => {
    this.setError('')
    this.setWarning('')
    this.setStatus(null)
    this.setDomainCheck(false)

    const result = await checkSingleUrl(url)

    this.setStatus(result.status)
    this.setDomainCheck(result.domainCheck)

    if (result.isWarning) {
      this.setWarning(this._config.warningText)
      return this
    }

    if (result.isError) {
      this.setError(this._config.errorText)
      return this
    }

    return this
  }

  dispose = () => {
    this._errorText = ''
    this._warningText = ''
    this._status = null
  }

  get domainCheck() {
    return this._domainCheck
  }

  get errorText() {
    return this._errorText
  }

  get warningText() {
    return this._warningText
  }

  get isError() {
    return this._status === EnumCheckUrlStatus.Error
  }

  get isSuccess() {
    return this._status === EnumCheckUrlStatus.Success
  }

  get isWarning() {
    return this._status === EnumCheckUrlStatus.Warning
  }
}
